import { c as _c } from "react/compiler-runtime";
import React from "react";

/**
 * Audio display component without interactive modal functionality.
 * Based on DropListItemContentMediaAudio but with optional controls.
 */
function MediaDisplayAudio(t0) {
  const $ = _c(3);
  const {
    src,
    showControls: t1
  } = t0;
  const showControls = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== showControls || $[1] !== src) {
    t2 = <div className="tw-w-full tw-h-full">{showControls ? <audio controls={true} className="tw-w-full tw-max-h-10"><source src={src} type="audio/mpeg" />Your browser does not support the audio element.</audio> : <div className="tw-bg-iron-850 tw-rounded-lg tw-p-2 tw-flex tw-items-center tw-justify-center"><span className="tw-text-iron-400 tw-text-xs">Audio</span></div>}</div>;
    $[0] = showControls;
    $[1] = src;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export default React.memo(MediaDisplayAudio);